import React from 'react';
import { Section } from './ui/Section';
import { Card } from './ui/Card';
import { Brain, Heart, Sparkles } from 'lucide-react';
export function AwarenessSection() {
  const items = [{
    icon: <Brain className="w-8 h-8 text-brand-primary" data-id="element-35" />,
    title: 'MINTEA',
    subtitle: 'Anxietate · Frici · Gânduri repetitive',
    description: 'Simți că mintea ta nu mai tace? Deși “funcționezi” la muncă și în viață, în interior e neliniște: scenarii, îngrijorări, tensiune, control, oboseală mentală. Uneori îți spui că ar trebui să poți singur… dar parcă te trage ceva înapoi.'
  }, {
    icon: <Heart className="w-8 h-8 text-brand-secondary" data-id="element-36" />,
    title: 'CORPUL',
    subtitle: 'Tensiune · Insomnii · Reactivitate',
    description: 'Corpul îți arată ce nu mai poți duce. Somn fragmentat, nod în gât, presiune în piept, stomac strâns, epuizare. Încerci să “împingi” peste, dar corpul ține scorul și te oprește când nu mai are resurse.'
  }, {
    icon: <Sparkles className="w-8 h-8 text-brand-accent" data-id="element-37" />,
    title: 'SUFLETUL & SENSUL',
    subtitle: 'Gol interior · Deconectare · Vinovăție',
    description: 'Simți că ți-ai pierdut direcția? Poate ai trecut prin pierderi, dezamăgiri, relații toxice, rupturi, sau pur și simplu ai ajuns într-un punct în care “ai realizări”, dar nu mai simți sens. Îți dorești pace, claritate și o reconectare autentică cu tine și cu Dumnezeu.'
  }];
  return <Section id="awareness" background="white" data-id="element-38">
      <div className="text-center mb-16" data-id="element-39">
        <h2 className="text-3xl md:text-4xl font-bold text-brand-text mb-4" data-id="element-40">
          Recunoști aceste semne în viața ta?
        </h2>
        <p className="text-lg text-gray-600 max-w-2xl mx-auto" data-id="element-41"></p>
      </div>

      <div className="grid md:grid-cols-3 gap-8" data-id="element-42">
        {items.map((item, index) => <Card key={index} variant="white" className="hover:shadow-lg transition-shadow duration-300" data-id="element-43">
            <div className="flex flex-col items-center text-center h-full" data-id="element-44">
              <div className="mb-6 p-4 bg-brand-bg rounded-full" data-id="element-45">
                {item.icon}
              </div>
              <h3 className="text-xl font-bold text-brand-text mb-2" data-id="element-46">
                {item.title}
              </h3>
              <p className="text-sm font-medium text-brand-primary mb-4 uppercase tracking-wide" data-id="element-47">
                {item.subtitle}
              </p>
              <p className="text-gray-600 leading-relaxed" data-id="element-48">
                {item.description}
              </p>
            </div>
          </Card>)}
      </div>
    </Section>;
}